import Api from '@/helpers/api';
/**
 * Obtiene la lista de estadística de todas las empresas, la cuales solo puede visualizar un usuario de tipo GOTU
 *
 * @returns {Promise<Stadics[]>} Promise - una promesa con la lista de las estadística
 */
const getAllStadistic = async () => {
    const result = await Api.get('/statistics');
    return result.data;
};

/**
 * Obtiene la información de una estadística, la cual contiene la url del tablero de dataStudio
 *
 * @param {string} id - Id de la estadística
 * @returns {Promise<Stadics>} Promise una promesa con la in formación de la estadística
 */
const getOneStadistic = async (id) => {
    const result = await Api.get(`/statistics/${id}`);
    return result.data;
};

/**
 * Guarda una estadística
 *
 * @param {object} statistic - un objeto con los datos de la estadística { name, uri, companyID}
 * @returns {Promise<Response>} Promise - una promesa con el estado del servicio
 */
const saveStadistic = async (statistic) => {
    const result = await Api.post('/statistics', statistic);
    return result.data;
};

/**
 * Actualiza un grupo
 *
 * @param {string} id - el Id de la estadística
 * @param {object} group - un objeto con los datos de la estadística a actualizar { name, uri, companyID}
 * @returns {Promise<Response>} Promise - una promesa con el estado del servicio
 */
const updateStadistic = async (id, statistic) => {
    const result = await Api.put(`/statistics/${id}`, statistic);
    return result.data;
};

/**
 * Elimina una estadística
 *
 * @param {string} id - el Id de la estadística
 * @returns {Promise<Response>} Promise - una promesa con el estado del servicio
 */
const deleteStadistic = async (id) => {
    const result = await Api.delete(`/statistics/${id}`);
    return result.data;
};

/**
 * Obtener companías
 *
 * @returns {Promise<Companies[]>} Promise - una promesa con el elistado de las compañías
 */
 const getComapnies = async () => {
    const result = await Api.get(`/companies`);
    return result.data;
};


export {
    getAllStadistic,
    getOneStadistic,
    saveStadistic,
    updateStadistic,
    deleteStadistic,
    getComapnies
};
